import { useContext } from 'react';
import styled from '@emotion/styled';
import { store } from '../store';
import { SET_IMAGE_SCALE } from '../types';

const MIN = 1;
const MAX = 3;
const STEP = 0.1;

const ScaleSlider = () => {
  const { scale, dispatch } = useContext(store);
  const handleScale = ({ target }) => {
    const newScale = +target.value;
    dispatch({ type: SET_IMAGE_SCALE, payload: newScale });
  };
  return (
    <ScaleContainer>
      <SliderContainer>
        <div>{scale}</div>
        <Slider>
          <MinMax>{MIN}</MinMax>
          <input
            type="range"
            value={scale}
            min={MIN}
            max={MAX}
            step={STEP}
            onChange={handleScale}
            style={{ width: 250 }}
          />
          <MinMax>{MAX}</MinMax>
        </Slider>
      </SliderContainer>
      <Label>Image Scale</Label>
    </ScaleContainer>
  );
};

const ScaleContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const SliderContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const MinMax = styled.div({
  color: '#999',
});

const Slider = styled.div({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  columnGap: 5,
  alignItems: 'center',
});

const Label = styled.div({});

export default ScaleSlider;
